export enum FieldValidatorType {
  MinMax,
  Pattern,
  Required,
  Email,
  LessMore,
  MaxLength,
}
